import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-95">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/oPz2ceztLFoxYzTK4HmgJt/Gloss__Chrome_Banner.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-96" />

      {/* Dark Gradient Overlay for Readability */}
      <div className="absolute inset-0 z-10 bg-gradient-to-t from-black/80 via-black/30 to-transparent" data-id="element-97" />

      {/* Content */}
      <div className="relative z-20 text-center px-6 max-w-5xl mx-auto flex flex-col items-center mt-20" data-id="element-98">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: [0.16, 1, 0.3, 1]
      }} className="font-syncopate font-bold text-4xl md:text-6xl lg:text-7xl text-white tracking-[0.15em] leading-tight mb-6" data-id="element-99">
          THE GLOSS &<br data-id="element-100" />
          CHROME LAB
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.4,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-white/90 text-lg md:text-xl font-light tracking-wide mb-12" data-id="element-101">
          Where Futurism Meets Artistry
        </motion.p>

        <motion.button initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.6,
        ease: [0.16, 1, 0.3, 1]
      }} className="bg-iridescent text-black font-semibold text-sm md:text-base tracking-widest uppercase px-8 py-4 rounded-full animate-pulse-glow hover:scale-105 transition-transform" data-id="element-102">
          Discover The Experience
        </motion.button>
      </div>

      {/* Liquid Blur Transition at Bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-32 z-20 backdrop-blur-xl liquid-blur-bottom bg-white/5" data-id="element-103" />
    </section>;
}